import React, { useEffect } from 'react';
import { useMovements } from './ModulosMovimientos';

import { MovimientosDesktop } from './Desktop';
import { MovimientosMobile } from './Movil';

import Loading from 'components/Loading';
import { useMooksConsultaMovimientos } from '../1-Consulta/ModulosConsulta/mocks';


export default function Movimientos() {
    // Services
    const {
        sendMovements,
        isMobile,
        respMovements,
        cargos,
        abonos,
        loading,
        errorCode
    } = useMovements();

    // Moks
    // const {
    //     sendMovements,
    //     isMobile,
    //     respMovements,
    //     cargos,
    //     abonos,
    //     loading,
    //     errorCode
    // } = useMooksConsultaMovimientos()


    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        window.ineum('page', 'Movements Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
        sendMovements()
    },[])

    return (
        <>
            { loading && <Loading /> }
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <MovimientosDesktop
                            isMobile={isMobile}
                            respMovements={respMovements}
                            cargos={cargos}
                            abonos={abonos}
                            errorCode={errorCode}
                        />
                    : 
                        <MovimientosMobile
                            isMobile={isMobile}
                            respMovements={respMovements}
                            cargos={cargos}
                            abonos={abonos}
                            errorCode={errorCode}
                        />
                : null
            }
        </>
    )
}